import { useState } from 'react';
import { Outlet } from 'react-router-dom';

import Sidebar from '../features/navigation/sidebar';
import Footer from '../features/footer/footer';
import { IconMenu } from '../common/icons';

import './styles/admin-shell.css';

// TSS vite/01 — authenticated layout shell. Renders the permission-filtered
// sidebar + the routed page (<Outlet>) + footer. On narrow screens the
// sidebar becomes an off-canvas drawer toggled from the top bar.

export default function AdminShell() {
    const [drawerOpen, setDrawerOpen] = useState(false);

    return (
        <div className="admin-shell">
            <div
                className={`admin-shell__scrim ${drawerOpen ? 'admin-shell__scrim--show' : ''}`}
                onClick={() => setDrawerOpen(false)}
                aria-hidden="true"
            />

            <div className={`admin-shell__aside ${drawerOpen ? 'admin-shell__aside--open' : ''}`}>
                <Sidebar onNavigate={() => setDrawerOpen(false)} />
            </div>

            <div className="admin-shell__body">
                <header className="admin-shell__topbar">
                    <button
                        type="button"
                        className="admin-shell__menu-btn"
                        onClick={() => setDrawerOpen(true)}
                        aria-label="Abrir menú"
                        aria-expanded={drawerOpen}
                    >
                        <IconMenu />
                    </button>
                    <span className="admin-shell__topbar-brand">COWRE</span>
                </header>

                <main className="admin-shell__main">
                    <Outlet />
                </main>

                <Footer />
            </div>
        </div>
    );
}
